import React, {useEffect, useState} from "react";
import GenericTemplate from "../../templates/GenericTemplate";
import {apollo_useStyles, valueToOption, options_infostate} from "../../atom/Apollo_styles";
import {APOLLO_SYSTEM_ADMIN, APOLLO_PROFILE_SYSTEM_ADMIN, ApolloPageUsagePermission} from "../../atom/Apollo_Authorization";
import {ApolloBreadcrumbs} from "../../atom/Apollo_Breadcrumbs";
import {
  apollo_info_path,
  infodetail_path,
  infoedit_path,
} from "../../atom/Apollo_links";
import {Info} from "./NotifyModel";
import {ApolloMessage, CustomizedSnackbars} from "../../atom/Apollo_Mesasge"
// メッセージ定義
import {
  GetMessage,
  UI_NOTIFY_LIST,
} from "../../atom/Apollo_MesasgeDefinition";
// 認証期間切れの処理
import {ApolloExpired} from "../../atom/Apollo_Expired";

import {Link, useHistory} from "react-router-dom";
import moment from "moment"
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Box from '@material-ui/core/Box';
import Fab from '@material-ui/core/Fab';
import AddIcon from '@material-ui/icons/Add';
import KeyboardArrowRightIcon from '@material-ui/icons/KeyboardArrowRight';
import {ApolloContext} from "../../atom/Apollo_Context";
import {ApolloDataTable, STORAGE_KEY} from "../../atom/Apollo_DataTable";
import {ApolloAxios} from "../../atom/Apollo_ApiRequest3";
import Tooltip from '@material-ui/core/Tooltip';
import Card from "@material-ui/core/Card/Card";
import {createMuiTheme} from "@material-ui/core/styles";
import {MUISortOptions, SelectableRows} from "mui-datatables";

/*
    画面名：通知メッセージ一覧画面
 */
const NotifyPage: React.FC = () => {
  const classes = apollo_useStyles();

  const {state} = React.useContext(ApolloContext);
  const {data, setmsg} = React.useContext(ApolloMessage);
  const [rows, setRows] = useState<Info[]>([]);

  let history = useHistory();

  useEffect(() => {
    const url = process.env.REACT_APP_API_ENDPOINT + apollo_info_path;
    ApolloAxios.get(url).then(response => {
      if (response.data.resultCode === 0) {
        setRows(response.data.result ?? []);
      }
    }).catch(err => {
      console.log(err)
      // 認証期間切れ判定とエラーメッセージ表示
      if (!ApolloExpired(err, GetMessage("0",UI_NOTIFY_LIST,"E","0"), data, setmsg, history)) {
        // 認証期間切れ以外のエラーで、エラーメッセージ表示後の処理があれば記述
      }
    });
  }, []);  

  const theme = createMuiTheme({});
  const columns = [
    {
      name: "infoId",
      label: "メッセージID",
      options: {
        filter: true,
        sort: true,
      }
    },
    {
      name: "infoName",
      label: "タイトル",
      options: {
        filter: true,
        sort: true,
      }
    },
    {
      name: "startAt",
      label: "配信開始日時",
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value: number) => {
          return moment(value).format("YYYY-MM-DD HH:mm");
        }
      }
    },
    {
      name: "status",
      label: "ステータス",
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value: number) => {
          return valueToOption(value, options_infostate).label;
        }
      }
    },
    {
      name: "createdAt",
      label: "作成日",
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value: number) => {
          return moment(value).format("YYYY-MM-DD");
        }
      }
    },
    {
      name: "createdBy",
      label: "作成者",
      options: {
        filter: true,
        sort: false,
      }
    },
    {
      name: "",
      label: "詳細",
      options: {
        filter: false,
        sort: false,
        customBodyRenderLite: (idx: number) => {
          return (
            <KeyboardArrowRightIcon
              onClick={() => history.push(infodetail_path + rows[idx].infoId + "?type=li")}
              className={classes.link}
              style={{cursor: "pointer"}}
            />
          );
        }
      },
    },
  ];

  const sortOrder: MUISortOptions = {
    name: "infoId",
    direction: 'desc',
  }
  const selectableRows: SelectableRows = 'none';
  const options = {
    filter: true,
    download: false,
    print: false,
    sort: true,
    sortOrder: localStorage.getItem(STORAGE_KEY.NOTIFY) ? undefined : sortOrder,
    selectableRows: selectableRows,
    rowsPerPage: 10,
    rowsPerPageOptions: [10, 25, 50],
    jumpToPage: true,
    expandableRows: true,
    expandableRowsHeader: false,
    expandableRowsOnClick: true,
    storageKey: STORAGE_KEY.NOTIFY,
    renderExpandableRow: (rowData: any, rowMeta: { rowIndex: number, dataIndex: number }) => {
      const colspan = rowData.length + 1;
      return (
        <TableRow>
          <TableCell colSpan={colspan}>
            <Box margin={1}>
              <Table size="small" aria-label="purchases">
                <TableHead>
                  <TableRow>
                    <TableCell align="left">本文</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  <TableRow>
                    <TableCell align="left"
                               style={{whiteSpace: "pre-line"}}>{rows[rowMeta.dataIndex].infoText}</TableCell>
                  </TableRow>
                </TableBody>
              </Table>
            </Box>
          </TableCell>
        </TableRow>
      );
    },
  }

  return (
    <GenericTemplate title="">
      <ApolloPageUsagePermission role={APOLLO_SYSTEM_ADMIN} profile={APOLLO_PROFILE_SYSTEM_ADMIN}>
        <ApolloBreadcrumbs bread_no={34} zeusaccountid={0} zeuscampaignid={0} adgroupid={0} adid={0} query={""}
                          platform={""}/>

        <Tooltip title="メッセージ作成" placement="bottom">
          <Link to={infoedit_path + "0"} className={classes.link}>
            <Fab size="small" color="primary" aria-label="add" style={{marginTop: "10px"}}>
              <AddIcon/>
            </Fab>
          </Link>
        </Tooltip>              
        <Card className={classes.root} square variant="outlined">
          <ApolloDataTable
            title=""
            data={rows ? rows : []}
            columns={columns}
            options={
              {
                ...options,
                textLabels:{
                  body: {noMatch: "該当データが存在しません"}
                },
              }
            }
          />
        </Card>
      </ApolloPageUsagePermission>
      <CustomizedSnackbars/>
    </GenericTemplate>
  );
};

export default NotifyPage;
